import { render } from "./levelCompetedSelector.vue?vue&type=template&id=239f017b&ts=true"
import script from "./levelCompetedSelector.vue?vue&type=script&lang=ts"
export * from "./levelCompetedSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__